'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var mapValuesWithKey = _mapValues2.default.convert({ cap: false });
var queueHandlersBefore = mapValuesWithKey(function (handler, name) {
  return function (props) {
    return function () {
      var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!props[name]) {
                  _context.next = 7;
                  break;
                }

                _context.t0 = props;
                _context.t1 = name;
                _context.next = 5;
                return handler(props).apply(undefined, _args);

              case 5:
                _context.t2 = _context.sent;
                return _context.abrupt('return', _context.t0[_context.t1].call(_context.t0, _context.t2));

              case 7:
                return _context.abrupt('return', handler(props).apply(undefined, _args));

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();
  };
});

exports.default = queueHandlersBefore;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/queueHandlersBefore.js
// module id = 1303
// module chunks = 0